import { render, staticRenderFns } from "./AddPoint.vue?vue&type=template&id=f24ccab6&scoped=true"
import script from "./AddPoint.vue?vue&type=script&lang=js"
export * from "./AddPoint.vue?vue&type=script&lang=js"
import style0 from "./AddPoint.vue?vue&type=style&index=0&id=f24ccab6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24ccab6",
  null
  
)

export default component.exports